import { render, staticRenderFns } from "./SubmitCard.vue?vue&type=template&id=5492f3be&scoped=true&"
import script from "./SubmitCard.vue?vue&type=script&lang=ts&"
export * from "./SubmitCard.vue?vue&type=script&lang=ts&"
import style0 from "./SubmitCard.vue?vue&type=style&index=0&id=5492f3be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5492f3be",
  null
  
)

export default component.exports